export const supportBasePath = 'https://support.greencheckverified.com';
export const knowledgeBasePath = `${supportBasePath}/knowledge`;
